//import actions from 'store/actions';
import {fromJS, OrderedMap, Map} from 'immutable';
import {union} from 'ramda';

import ParamsParser from '@synergycms_core/utils/paramsParser';

const requiredParams = [];

export default {
    //Acció utilitzada per inicialitzar els parametres i corregirlos a partir del obj parsejat de la url
    CREATE_FROM_URL: (newParams, currentStep) => (dispatch, getState) => {


        const params = OrderedMap({
            extended_testing_mode: newParams.get('extended_testing_mode', null),
            tpv_result: newParams.get('tpv_result', null),
            referer_code: newParams.get('referer_code', null),
            promotion_code: newParams.get('promotion_code', null)
        });

        //modo testing
        window.availabilityReactTestingMode =
            newParams.get('testing_mode', false) || newParams.get('extended_testing_mode', false);

        const newValidParams = ParamsParser.paramsToUrl(
            newParams,
            union(requiredParams, newParams.keySeq().toJS())
        );

        return Map({
            url_params: newValidParams,
            params: params
        });
    },
    //acció utilitzada per modificar els parametres un cop ja els tenim inicialitzats, en aquest cas rebem un inmutable del params de store
    UPDATE_PARAMS: (newParams = Map(), type) => (dispatch, getState) => {
        const store = getState();
        const params = store.getIn(['customer', 'params', 'params']);

        const updatedParams = params.merge(newParams);

        const newValidParams = ParamsParser.paramsToUrl(
            updatedParams,
            union(requiredParams, updatedParams.keySeq().toJS())
        );

        //const validParams = !!(newValidParams.get('hotelCode') || newValidParams.get('hotelCodes', List()).size);
        return fromJS({
            url_params: newValidParams,
            params: updatedParams
        });
    }
};
